import { useEffect, useState } from "react";

/**
 * Same navigator.onLine + online/offline listener pattern already used in
 * StaffNotepad.jsx and offline.html, extracted into one shared hook so the
 * public site's offline indicator and any "this needs the internet" copy
 * don't each reimplement it independently.
 */
export default function useOnlineStatus() {
  const [online, setOnline] = useState(
    typeof navigator === "undefined" ? true : navigator.onLine,
  );
  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);
  return online;
}
